import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { Provider } from "react-redux";
import { serialize } from 'next-mdx-remote/serialize'
import { readFile } from 'fs/promises'
import { MDXRemote } from 'next-mdx-remote'
import PageHead from "../../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import Banner from "@/components/Common/Banner";
import BackToTop from "../../backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";

export default function LegalDocs({ mdxSource }) {
  const router = useRouter();
  const docId = router.query.docId;
  const docTitle = (docId== "privacy-policy") ? "Privacy Policy" : "Terms of Use" 

  useEffect(() => {
    if (docId && mdxSource) {
      // router.push("/");
    }
  }, [router]);

  return (
    <>
      <PageHead title="Learn Cloud Computing through Shorts" category="Legal Document" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />
          <Banner col="col-lg-12" text={docTitle}/>
          <br/><br/><br/><br/><br/>
          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <MDXRemote {...mdxSource} />
            </div>
          </div>
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export async function getStaticProps(context) {
  const docId = context.params.docId
  const fileName = `./content/legal/${docId}.mdx`
  // MDX text - can be from a local file, database, CMS, fetch, anywhere...
  const mdxText = await readFile(fileName, 'utf8')
  const mdxSource = await serialize(mdxText)
  return { props: { docId, mdxSource } }
}

export async function getStaticPaths(context) {
  const paths = [
    { params: { docId: "privacy-policy" } },
    { params: { docId: "terms-of-use" } }
  ]
  return { paths, fallback: false }
}